import { Component, Inject, OnInit } from '@angular/core';

import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Paginacao } from "@app/models/util/paginacao";
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';

import { EstadoDoProcesso } from '@app/models/estado-do-processo.model';
import { EstadoDoProcessoService } from '@app/services/estado-do-processo.service';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-estado-do-processo-lista',
  templateUrl: './estado-do-processo-lista.component.html'
})

export class EstadoDoProcessoListaComponent implements OnInit {

  bsModalRef: BsModalRef;
  paginacao: Paginacao = new Paginacao();
  filtroDescricao: string = "";

  estadosDosProcessos: EstadoDoProcesso[] = [];

  constructor(
    @Inject(ToastrService) public toastr: ToastrService,
    private estadoDoProcessoService: EstadoDoProcessoService,
    private modalService: BsModalService) { }

  ngOnInit() {
    this.obterTodos(this.filtroDescricao, 1);
  }

  pesquisar() {
    this.obterTodos(this.filtroDescricao, 1);
    this.paginacao.paginaAtual = 1;
  }

  obterTodos(descricao: string, pagina: number) {
    this.estadoDoProcessoService.obterPesquisa(descricao, pagina).toPromise().then(
      data => {
        this.estadosDosProcessos = data.Dados,
          this.paginacao.totalDeItens = data.Total
      }, erro => {
        this.toastr.warning("Realize a pesquisa novamente.")
      });
  }

  deletar(estadoDoProcesso: EstadoDoProcesso) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = "Deseja realmente excluir o estado do processo: " + estadoDoProcesso.Descricao + "?";
    this.bsModalRef.content.confirmar = () => {
      this.estadoDoProcessoService.deletar(estadoDoProcesso.Id).toPromise().then(() => {
        this.obterTodos(this.filtroDescricao, 1);
        this.paginacao.paginaAtual = 1;
      });
    }
  }

  public pageChanged(event: any): void {
    this.obterTodos(this.filtroDescricao, event.page);
  }
}
